import { render, staticRenderFns } from "./beCareful.vue?vue&type=template&id=c4057024&scoped=true&"
import script from "./beCareful.vue?vue&type=script&lang=js&"
export * from "./beCareful.vue?vue&type=script&lang=js&"
import style0 from "./beCareful.vue?vue&type=style&index=0&id=c4057024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4057024",
  null
  
)

export default component.exports